import axios from "axios";

import {
  IInitializeResponse,
  IInstitution,
} from "@krea/customer-features/store/banking-data/types.ts";

export const getInstitutions = async (
  resourceId: string,
  resourceType: string,
): Promise<IInstitution[]> => {
  const response = await axios.get<IInstitution[]>(
    `/api/v1/banking-data/sessions/institutions`,
    {
      params: {
        resourceId,
        resourceType,
      },
    },
  );

  return response.data;
};

export const initialize = async (
  institutionId: string,
  redirectUrl: string,
  locale: string,
): Promise<IInitializeResponse> => {
  const response = await axios.post<IInitializeResponse>(
    `/api/v1/banking-data/sessions/initialize`,
    {
      institutionId,
      redirectUrl,
      locale,
    },
  );

  return response.data;
};

export const finalize = async (
  resourceId: string,
  resourceType: string,
  requisitionId: string,
): Promise<void> => {
  await axios.post("/api/v1/banking-data/sessions/finalize", {
    resourceId,
    resourceType,
    requisitionId,
  });
};
